// extracted by mini-css-extract-plugin
export var avatarContainer = "_az-0";
export var avatarTypingWave = "_az-i";
export var gray = "_az-f";
export var green = "_az-c";
export var icon = "_az-9";
export var image = "_az-1";
export var lg = "_az-6";
export var md = "_az-5";
export var presenceDot = "_az-b";
export var red = "_az-d";
export var sm = "_az-4";
export var status = "_az-a";
export var typingDot = "_az-h";
export var typingPill = "_az-g";
export var xl = "_az-7";
export var xs = "_az-3";
export var xxl = "_az-8";
export var xxs = "_az-2";
export var yellow = "_az-e";